import type MatchReviewRepository from "@/core/compliance/repositories/MatchReviewRepository";
import type {
  MatchReview,
  QualifyMatchPayload,
} from "@/core/compliance/entities/MatchReview";
import type { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import l1ReviewEndpoints from "../../api/l1ReviewEndpoints/l1ReviewEndpoints";
import { type MatchReviewDto, mapMatchReviewDtoToEntity } from "./mappers";

export default class MatchReviewRepositoryBackend
  implements MatchReviewRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getMatches(reviewId: string): Promise<RepositoryResult<MatchReview>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<MatchReviewDto>>({
          url: l1ReviewEndpoints.matches(reviewId),
          withAuth: true,
        }),
      mapMatchReviewDtoToEntity,
    );
  }

  async qualifyMatch(
    reviewId: string,
    matchId: string,
    payload: QualifyMatchPayload,
  ): Promise<RepositoryResult<MatchReview>> {
    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<MatchReviewDto>, QualifyMatchPayload>({
          url: l1ReviewEndpoints.qualifyMatch(reviewId, matchId),
          body: payload,
          withAuth: true,
        }),
      mapMatchReviewDtoToEntity,
    );
  }
}
